// extracted by mini-css-extract-plugin
export default {"reg_wrong":"styles_reg_wrong__PSgFy","reg_wrong__img":"styles_reg_wrong__img__pdZAz","reg_wrong__invalid_link":"styles_reg_wrong__invalid_link__J0k3u"};